import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { CgBlock, CgUnblock } from 'react-icons/cg';
import { RiCoupon3Line } from 'react-icons/ri';
import Pagination from 'react-js-pagination';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { promoCodeListApi } from 'services/promocode';
import { formatValidTillDate } from 'utils/common';
import findSerialNumber from 'utils/findSerialNumber';
import BlockPromoCode from './section/BlockPromoCode';
import { Line } from 'recharts';
import ReadMore from 'utils/readMoreModal/ReadMore';
import DeletePromoCode from './section/DeletePromoCode';
import { FaEdit, FaRegTrashAlt } from 'react-icons/fa';
import { SwitchButton } from 'components/form';

const PromoCodeManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [promoCodeList, setPromoCodeList] = useState([]);
    const [showFull, setShowFull] = useState(false);
    const activePage = +searchParams.get("page") || 1;
    const limit = +searchParams.get("limit") || 10;
    const total = +searchParams.get("total") || 1;
    const [blockData, setBlockData] = useState({ modal: false })
    const [readMoreData, setReadMoreData] = useState({ modal: false })
    const [deleteData, setDeleteData] = useState({ modal: false })
    const navigate = useNavigate()

    //------------Handel-Pagination------------
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };

    // ----------handle-block-----------
    const handleBlock = (data) => {
        setBlockData({ ...data, modal: true })
    }
    // ----------handle-delete-----------
    const handleDelete = (data) => {
        setDeleteData({ ...data, modal: true })
    }
    // -----------read-more-modal-------------
    const handleReadMore = (data) => {
        setReadMoreData({ description: data, modal: true, title: 'Message' })
    }
    const fetchPromoCodeList = async () => {
        const query = {
            page: activePage,
            limit: limit,
        };
        onShow();
        try {
            const res = await promoCodeListApi(query);
            const { code, data } = res?.data;
            if (code === 200) {
                const urlResponse = new URLSearchParams(searchParams);
                urlResponse.set("total", data?.total);
                setSearchParams(urlResponse);
                setPromoCodeList(data?.data || []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        fetchPromoCodeList();
    }, [activePage, limit]);

    return (
        <div className="user-management-container">
            <div className="page_title has_child">
                <h3>Promocode Management</h3>
                <div className="tabContainer">
                    <Link to='/promocode-management/add'>
                        <button
                            className="button"
                            type="button"
                        >
                            Add Promo Code
                        </button>
                    </Link>
                </div>
            </div>
            {/* ---------card */}
            <div className="card">
                {loader}
                <div className="table-container">
                    <table className="table custom_table">
                        <thead>
                            <tr>
                                <th className="nowrap text-center">S.No</th>
                                <th className="nowrap text-center">Coupon Code</th>
                                {/* <th className="nowrap text-center">ID </th> */}
                                <th className="nowrap text-center">Details</th>
                                <th className="nowrap text-center">Valid till</th>
                                <th className="nowrap text-center">Type</th>
                                <th className="nowrap text-center">Value</th>
                                <th className="nowrap text-center">Status</th>

                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {promoCodeList.length > 0 ? (
                                promoCodeList?.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="nowrap text-center">
                                                {findSerialNumber(index, activePage, limit)}
                                            </td>

                                            <td className="nowrap text-center">
                                                {data?.couponCode || "N/A"}
                                            </td>

                                            {/* <td className="nowrap text-center">
                                                {data?.couponCode || "N/A"}
                                            </td> */}
                                            <td className="nowrap text-center">
                                                {data.description.length > 15
                                                    ? <>
                                                        {data.description.slice(0, 15)}...
                                                        <span
                                                            onClick={() => handleReadMore(data.description)}
                                                            style={{ color: "blue", cursor: "pointer" }}
                                                        >
                                                            Read More
                                                        </span>
                                                    </>
                                                    : data.description || "N/A"
                                                }
                                            </td>

                                            <td className="nowrap text-center">
                                                {formatValidTillDate(data?.startDate, data?.endDate)}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.discountType || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.discountValue || "N/A"}
                                            </td>

  <td className="nowrap text-center">
                                              <div className="button-container">
  <div
    onClick={() => handleBlock(data)}
    style={{
      color: data?.status === "ACTIVE" ? "green" : "red",
      fontWeight: 600,
      cursor: "pointer"
    }}
  >
    {data?.status === "ACTIVE" ? "Show" : "Hide"}
  </div>
</div>

                                            </td>

                                            

                                            <td className="nowrap text-center">
                                                <div className="button-container">
                                                    <div onClick={() => handleBlock(data)}>
                                                        <SwitchButton
                                                            status={data?.status === "ACTIVE" ? true : false}
                                                            disabled={data?.status === "DELETED"}
                                                        />
                                                    </div>

                                                    

                                                    <button
                                                        onClick={() => {
                                                            navigate(
                                                                `/promocode-management/edit/${data?._id}`
                                                            );
                                                        }}
                                                    >
                                                        <FaEdit />
                                                    </button>

                                                    <button
                                                        type="button"
                                                        onClick={() => handleDelete(data)}
                                                    >
                                                        <FaRegTrashAlt />
                                                    </button>

                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={7}
                                    msg={"Promocode not found"}
                                    onHide={onHide}
                                    icon={<RiCoupon3Line />}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* ---------change-status------------------- */}
            <BlockPromoCode
                show={blockData?.modal}
                close={() => setBlockData((prev) => ({ ...prev, modal: false }))}
                listing={fetchPromoCodeList}
                promoCodeData={blockData}
                promoCodeList={promoCodeList}
                setPromoCodeList={setPromoCodeList}
            />
            {/* ---------delete-------------------- */}
            <DeletePromoCode
                modal={deleteData?.modal}
                close={() => setDeleteData((prev) => ({ ...prev, modal: false }))}
                selectedData={deleteData}
                setState={setPromoCodeList}
            />
            {/* ---------read-more------------------- */}
            <ReadMore
                show={readMoreData?.modal}
                close={() => setReadMoreData({ ...readMoreData, modal: false })}
                title={readMoreData?.title}
                description={readMoreData?.description}
            />
            {/* ------pagination */}

            {total > limit && (
                <div className="pagination-wrapper">
                    <div className="Pagination">
                        <Pagination
                            activePage={activePage}
                            previousLabel={"previous"}
                            nextLabel={"next"}
                            itemsCountPerPage={limit}
                            totalItemsCount={total}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            hideDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default PromoCodeManagement